import React from 'react';

// Styles & Assets
import styles from './ContactPersonButton.module.css';
import { MdClose } from 'react-icons/md';

// Models
interface Props {
    title: React.ReactNode
    subtitles: string[]
    handleDeleteContact: () => void
    handleClickContact: () => void
}


const ContactPersonButton: React.FC<Props> = ({ title, subtitles, handleClickContact, handleDeleteContact }) => {

    return (
        <div className={styles.userContainer}>
            <button onClick={handleDeleteContact}>
                <MdClose />
            </button>
            <button onClick={handleClickContact} className={styles.carer}>
                <div>
                    <h3 className={styles.carerTitle}>
                        {title}
                    </h3>
                    {subtitles.map((s, i) =>
                        <p key={i} className={styles.textInfoCarer}>
                            {s}
                        </p>
                    )}
                </div>
            </button>
        </div>
    );
};

export default ContactPersonButton;